// extracted by mini-css-extract-plugin
export default {"wrap":"Timer_wrap__r76dD","content":"Timer_content__6ur1I"};